import FormInputLabel from "lib/formInputs/formInputGroups/FormInputLabel";
import _debounce from "lodash/debounce";
import React, { useCallback, useState } from "react";
import Form from "react-bootstrap/Form";
import PropTypes from "prop-types";

import generalConfig from "configs/generalConfig";

function SearchBox({ search = "", setSearch, className }) {
  const [value, setValue] = useState(search);
  const handleChange = (val) => {
    setValue(val);
    debounceFn(val);
  };
  const debounceFn = useCallback(
    _debounce((value) => setSearch(value), generalConfig.DEBOUNCE_TIMER),
    []
  );
  return (
    <div className={`mb-0 me-0 me-xxl-4 ${className}`}>
      <FormInputLabel formLabel="Search Box" className="visually-hidden" />
      <Form.Control
        type="search"
        className="search-icon-left"
        placeholder="Search"
        value={value}
        onChange={(e) => {
          handleChange(e?.target?.value?.trimStart());
        }}
      />
    </div>
  );
}
SearchBox.propTypes = {
  search: PropTypes.string,
  setSearch: PropTypes.func.isRequired,
  className: PropTypes.string,
};
export default SearchBox;
